<script>
import bem from '@/utils/bem';
import styles from './title-with-lines-block-style.scss';

const b = bem('title-with-lines-block', styles);

export default {
  name: 'TitleWithLinesBlock',
  props: {
    className: {
      type: String,
      default: '',
    },
    textList: {
      type: Array,
      default: () => [],
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    isMobileView: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editableTexts: [],
    };
  },
  computed: {
    b() {
      return b;
    },
  },
  mounted() {
    this.initializeEditableTexts();
  },
  watch: {
    textList: {
      handler() {
        this.initializeEditableTexts();
      },
      immediate: true,
    },
    editData: {
      handler() {
        if (this.isEdit && this.editData && Array.isArray(this.editData)) {
          this.initializeEditableTexts();
        }
      },
      immediate: true,
    },
    editableTexts: {
      handler(newValue, oldValue) {
        if (this.isEdit && oldValue && oldValue.length > 0) {
          // Проверяем, действительно ли есть изменения
          let hasChanges = false;
          const updates = {};

          newValue.forEach((item, index) => {
            const oldItem = oldValue[index];
            if (oldItem && (item.text !== oldItem.text
              || item.secondText !== oldItem.secondText)) {
              hasChanges = true;
              if (item.text !== oldItem.text) {
                updates[`${index}.text`] = item.text;
              }
              if (item.secondText !== oldItem.secondText) {
                updates[`${index}.secondText`] = item.secondText;
              }
            }
          });

          if (hasChanges && Object.keys(updates).length > 0) {
            this.$emit('update-text', updates);
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    initializeEditableTexts() {
      if (this.isEdit && this.editData && Array.isArray(this.editData)
        && this.editData.length > 0) {
        const newEditableTexts = this.editData.map((item) => ({
          text: item.text || '',
          secondText: item.secondText || '',
        }));

        if (JSON.stringify(newEditableTexts) !== JSON.stringify(this.editableTexts)) {
          this.editableTexts = newEditableTexts;
        }
      } else {
        const newEditableTexts = this.textList.map((item) => ({
          text: item.text || '',
          secondText: item.secondText || '',
        }));

        if (JSON.stringify(newEditableTexts) !== JSON.stringify(this.editableTexts)) {
          this.editableTexts = newEditableTexts;
        }
      }
    },
  },
};
</script>

<template>
  <div :class="b({ mix: className, isMobileView })">
    <div
      v-for="(item, itemIndex) in textList"
      :key="item.id"
      :class="b('item')"
    >
      <div
        :class="b('text-block', {
          isLeft: (!isMobileView && item.isLeft) || (isMobileView && item.isLeftMob),
          isRight: (!isMobileView && item.isRight) || (isMobileView && item.isRightMob),
          isTextReverse: (!isMobileView && item.isTextReverse) ||
            (isMobileView && item.isTextReverseMob),
          isTextReverseColumn: (!isMobileView && item.isTextColumn && item.isTextReverse) ||
            (isMobileView && item.isTextColumnMob && item.isTextReverseMob),
          isColumn: (!isMobileView && item.isTextColumn) || (isMobileView && item.isTextColumnMob),
          isTopLine: (!isMobileView && item.isTopLine) || (isMobileView && item.isTopLineMob),
          isMobileView,
        })"
      >
        <div
          v-if="(isMobileView && item.textMob) || (!isMobileView && item.text)"
          :class="b('text', {
            withLine: (!isMobileView && item.isTextWithLine) ||
              (isMobileView && item.isTextWithLineMob),
            isMobileView,
          })"
          :style="{ color: isMobileView ? item.colorMob : item.color }"
        >
          <a-input
            v-if="isEdit"
            :class="b('text-input')"
            :placeholder="`Enter ${isMobileView ? 'mobile' : 'desktop'} text`"
            v-model:value="editableTexts[itemIndex].text"
          />
          <span v-else :class="b('text-content')">
            {{ isMobileView ? item.textMob : item.text }}
          </span>
          <div
            v-for="line in item?.firstTextLines || []"
            :key="line.id"
            :class="b('line', {
              isShow: (!isMobileView && item.isTextWithLine) ||
                (isMobileView && item.isTextWithLineMob),
              isLeft: (!isMobileView && line.isLeftLine) ||
                (isMobileView && line.isLeftLineMob),
              isRight: (!isMobileView && line.isRightLine) ||
                (isMobileView && line.isRightLineMob),
              isTop: (!isMobileView && line.isTopLine) ||
                (isMobileView && line.isTopLineMob),
              isBottom: (!isMobileView && line.isBottomLine) ||
                (isMobileView && line.isBottomLineMob),
              isTopBottomLeft: (!isMobileView && line.isLeftLine &&
                (line.isTopLine || line.isBottomLine)) ||
                (isMobileView && line.isLeftLineMob &&
                (line.isTopLineMob || line.isBottomLineMob)),
              isTopBottomRight: (!isMobileView && line.isRightLine &&
                (line.isTopLine || line.isBottomLine)) ||
                (isMobileView && line.isRightLineMob &&
                (line.isTopLineMob || line.isBottomLineMob)),
              isMobileView,
            })"
            :style="{
              backgroundColor: isMobileView ? line.colorMob : line.color,
            }"
          >
            <div
              v-if="((!isMobileView && line.isLineWithSquare) ||
                (isMobileView && line.isLineWithSquareMob))"
              :class="b('line-square', {
                isLeft: (!isMobileView && line.isLeftLine) || (isMobileView && line.isLeftLineMob),
                isRight: (!isMobileView && line.isRightLine)
                || (isMobileView && line.isRightLineMob),
                isMobileView,
              })"
              :style="{
                backgroundColor: isMobileView ? line.colorMob : line.color,
              }"
            />
          </div>
        </div>
        <div
          v-if="(isMobileView && item.secondTextMob) || (!isMobileView && item.secondText)"
          :class="b('text-second', {
            withLine: (!isMobileView && item.isSecondTextWithLine)
            || (isMobileView && item.isSecondTextWithLineMob),
            isMobileView,
          })"
          :style="{ color: isMobileView ? item.colorMob : item.color }"
        >
          <a-input
            v-if="isEdit"
            :class="b('text-input')"
            :placeholder="`Enter ${isMobileView ? 'mobile' : 'desktop'} second text`"
            v-model:value="editableTexts[itemIndex].secondText"
          />
          <span v-else :class="b('text-content')">
            {{ isMobileView ? item.secondTextMob : item.secondText }}
          </span>
          <div
            v-for="line in item?.secondTextLines || []"
            :key="line.id"
            :class="b('line', {
              isShow: (!isMobileView && item.isSecondTextWithLine) ||
                (isMobileView && item.isSecondTextWithLineMob),
              isLeft: (!isMobileView && line.isLeftLine) ||
                (isMobileView && line.isLeftLineMob),
              isRight: (!isMobileView && line.isRightLine) ||
                (isMobileView && line.isRightLineMob),
              isTop: (!isMobileView && line.isTopLine) ||
                (isMobileView && line.isTopLineMob),
              isBottom: (!isMobileView && line.isBottomLine) ||
                (isMobileView && line.isBottomLineMob),
              isTopBottomLeft: (!isMobileView && line.isLeftLine &&
                (line.isTopLine || line.isBottomLine)) ||
                (isMobileView && line.isLeftLineMob &&
                (line.isTopLineMob || line.isBottomLineMob)),
              isTopBottomRight: (!isMobileView && line.isRightLine &&
                (line.isTopLine || line.isBottomLine)) ||
                (isMobileView && line.isRightLineMob &&
                (line.isTopLineMob || line.isBottomLineMob)),
              isMobileView,
            })"
            :style="{
              backgroundColor: isMobileView ? line.colorMob : line.color,
            }"
          >
            <div
              v-if="((!isMobileView && line.isLineWithSquare) ||
                (isMobileView && line.isLineWithSquareMob))"
              :class="b('line-square', {
                isLeft: (!isMobileView && line.isLeftLine) || (isMobileView && line.isLeftLineMob),
                isRight: (!isMobileView && line.isRightLine)
                || (isMobileView && line.isRightLineMob),
                isMobileView,
              })"
              :style="{
                backgroundColor: isMobileView ? line.colorMob : line.color,
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
